import { NgModule } from '@angular/core';
import { TypeheadComponent } from './typehead.component';

@NgModule({
  declarations: [TypeheadComponent],
  imports: [
  ],
  exports: [TypeheadComponent]
})
export class TypeheadModule { }
